export default __webpack_public_path__ + "static/media/NIAS0600.34I-42725_-25532_0.6622da35.jpg";